module.exports = __webpack_public_path__ + "static/media/logo-onoiwa-ori.ffbfe585.png";